import { render, staticRenderFns } from "./PosTour.vue?vue&type=template&id=7d9dd9e8&scoped=true"
import script from "./PosTour.vue?vue&type=script&lang=js"
export * from "./PosTour.vue?vue&type=script&lang=js"
import style0 from "./PosTour.vue?vue&type=style&index=0&id=7d9dd9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9dd9e8",
  null
  
)

export default component.exports